

import { DragLayerMonitorProps } from '@minoru/react-dnd-treeview';

import { SpaceNodeData } from '../hooks/use-space-tree-data';

interface SpaceDragPreviewProps {
  MonitorProps: DragLayerMonitorProps<SpaceNodeData>;
}

export function SpaceDragPreview({ MonitorProps }: SpaceDragPreviewProps) {
  const { item } = MonitorProps;

  return (
    <div className="inline-flex items-center bg-cyan-500 rounded-md text-white font-medium text-sm pointer-events-none px-3 py-1.5 min-w-[200px] drop-shadow-lg">
      <div className="item-center flex">{item.text}</div>
    </div>
  );
}
